import { NS_CONFIGURATION, PROJECT, EDITOR, ITEM, CURRENT } from 'redux/constants';
import { action, createType, ASYNC, SYNC } from 'redux-create-type';
import * as _statusFlow from './statusFlow/actions';


export const statusFlow = _statusFlow;

export const {
  SET_ITEM,
  SET_NAME,
  SET_IS_ACTIVE,
  SET_ITEM_COLOR,
  SET_CONTAINER_TYPE,
  SET_CONTAINER_FOR,
  INVALIDATE_CHANGES,
  CHECK_VALIDATION,
  SELECT_ITEMTYPE,
  RESET_CHANGES,
  SET_REMOVED,
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, ITEM, CURRENT)({
    SET_ITEM: ASYNC,
    SET_NAME: SYNC,
    SET_IS_ACTIVE: SYNC,
    SET_ITEM_COLOR: SYNC,
    SET_CONTAINER_TYPE: ASYNC,
    SET_CONTAINER_FOR: SYNC,
    INVALIDATE_CHANGES: SYNC,
    CHECK_VALIDATION: ASYNC,
    RESET_CHANGES: ASYNC,
    SELECT_ITEMTYPE: ASYNC,
    SET_REMOVED: SYNC,
  });



export const setItem = {
  begin: id => action(SET_ITEM.BEGIN, { id }),
  end: ({ selectedItem }) => action(SET_ITEM.END, { selectedItem }),
};
export const setRemoved = value => action(SET_REMOVED, { value });
export const setName = name => action(SET_NAME, { name });
export const setIsActive = value => action(SET_IS_ACTIVE, { value });
export const setItemColor = value => action(SET_ITEM_COLOR, { value });
export const selectItemType = {
  begin: ({id, type}) => action(SELECT_ITEMTYPE.BEGIN, {id:id, itemType:type }),
  end: ({item}) => action(SELECT_ITEMTYPE.END, {item}),
};

export const setContainerType = {
  begin: containerType => action(SET_CONTAINER_TYPE.BEGIN, { containerType }),
  end: ({ curentOptions }) => action(SET_CONTAINER_TYPE.END, { curentOptions }),
};
export const setContainerFor = options => action(SET_CONTAINER_FOR, { options });
export const invalidateChanges = ({ changes }) => action(INVALIDATE_CHANGES, { changes });
export const checkValidation = {
  begin: () => action(CHECK_VALIDATION.BEGIN, { }),
  end: ({ errors }) => action(CHECK_VALIDATION.END, { errors }),
};
export const resetChanges = {
  begin: () => action(RESET_CHANGES.BEGIN),
  end: ({
    item,
    }) => action(RESET_CHANGES.END, {
      item,
    }),
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/itemType/currentItem/actions.js